import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH = 'exchangeRate/FETCH';
const FETCH_SUCCESS = 'exchangeRate/FETCH_SUCCESS';
const FETCH_FAIL = 'exchangeRate/FETCH_FAIL';

const initialState = {
  exchangeRate: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        exchangeRate: action.result.data
      };
    case FETCH_FAIL:
      return {
        ...state,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function fetchExchangeRate(currency) {
  return {
    types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
    promise: client => client.get(`/exchangeRate?currency=${currency}`, {})
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/exchangeRate.js